import React, { useEffect, useState } from 'react';
import './ContactBody.css';
import { AnimatedSection } from '../../AnimatedSection';
import { db } from '../../../firebase';
import { collection, addDoc } from 'firebase/firestore';

const ContactBody = () => {
    // Form state management
    
    const playerImages = [
        '/home_data/section2/photo-frame/1.png',
        '/home_data/section2/photo-frame/2.png',
        '/home_data/section2/photo-frame/3.png',
        '/home_data/section2/photo-frame/4.png',
        '/home_data/section2/photo-frame/5.png',
        '/home_data/section2/photo-frame/6.png',
        '/home_data/section2/photo-frame/7.png',
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === playerImages.length - 1 ? 0 : prevIndex + 1
            );
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        email: '',
        message: '',
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(''); // 'success' or 'error'

    // Validation functions
    const validateName = (name) => {
        const nameRegex = /^[a-zA-Z\s]+$/;
        return nameRegex.test(name) && name.trim().length >= 2;
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^[\+]?[0-9\s\-\(\)]+$/;
        return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Validate entire form
    const validateForm = () => {
        const newErrors = {};

        if (!formData.fullName.trim()) {
            newErrors.fullName = 'Full name is required';
        } else if (!validateName(formData.fullName)) {
            newErrors.fullName = 'Full name must contain only letters';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        if (!formData.phoneNumber.trim()) {
            newErrors.phoneNumber = 'Phone number is required';
        } else if (!validatePhone(formData.phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid phone number';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        setSubmitStatus('');

        try {
            if (!validateForm()) {
                setIsSubmitting(false);
                return;
            }

            await addDoc(collection(db, 'contacts'), {
                ...formData,
                timestamp: new Date(),
                createdAt: new Date().toISOString()
            });

            setSubmitStatus('success');
            setFormData({
                fullName: '',
                phoneNumber: '',
                email: '',
                message: ''
            });
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (


        <section className="contactbody section">

            <div className=" bg-black flex flex-col md:flex-row contact-container">
                {/* Left side: Image */}
            <div className="player-image-container md:w-2/5 flex items-center justify-center relative p-10 pt-20 md:pt-0">
                    <AnimatedSection>

                        <img
                            src={playerImages[currentImageIndex]}
                            alt="Player"
                            className="player-image w-full h-[130vw] md:h-auto object-cover"
                        />

                        {/* <img
                            src="/contact_data/bodysection/Photo Frame.png"
                            alt="GAME7 player"
                            className="w-full h-auto object-cover"
                        /> */}

                    </AnimatedSection> 
                    {/* If you want overlay text like "GAME7", uncomment below */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <img
                            src="/contact_data/bodysection/Photo Frame.svg"
                            alt="GAME7 player"  className="w-1/3"
                        />
                    </div>
                </div>

                {/* Right side: Form */}
                <div className="md:w-3/5 items-center justify-center pt-20 pr-10 pb-10 pl-10 md:pl-10">
                    <form onSubmit={handleSubmit} className="w-100   space-y-8 text-white contact-options">

                        {/* Inputs */}
                        <div className='flex flex-col gap-5'>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.fullName ? 'border-red-400' : ''}`}
                                        type="text"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        placeholder="Full Name"
                                    />
                                    {errors.fullName && <p className="text-red-400 text-sm mt-1">{errors.fullName}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.phoneNumber ? 'border-red-400' : ''}`}
                                        type="tel"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        placeholder="Phone Number"
                                    />
                                    {errors.phoneNumber && <p className="text-red-400 text-sm mt-1">{errors.phoneNumber}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.email ? 'border-red-400' : ''}`}
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Email Address"
                                    />
                                    {errors.email && <p className="text-red-400 text-sm mt-1">{errors.email}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <textarea
                                        className="w-full contact-form-input"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        placeholder="How can we help?"
                                        rows={5}
                                    />
                                </div>
                            </AnimatedSection>

                        </div>

                        {/* Success/Error Messages */}
                        {submitStatus === 'success' && (
                            <div className="bg-black-600 text-white p-4 rounded-lg">
                                ✅ Thank you! Your message has been sent successfully.
                            </div>
                        )}

                        {submitStatus === 'error' && (
                            <div className="bg-red-600 text-white p-4 rounded-lg">
                                ❌ Sorry, there was an error sending your message. Please try again.
                            </div>
                        )}

                        {/* Submit Button */}
                        <AnimatedSection>
                            <div className="w-full flex justify-center md:justify-start">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`site-dft-btn-contact rounded-lg ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    {isSubmitting ? 'SENDING...' : 'SUBMIT'}
                                </button>
                            </div>
                        </AnimatedSection>
                    </form>
                </div>
            </div >

        </section >
    );
};

export default ContactBody;

